<template>
  <!-- 组件根元素 -->
  <div>
    <div
      class="image-container"
      @mouseenter="showMask = true"
      @mouseleave="showMask = false"
    >
      <!-- 显示图片，src 通过 props 传入 -->
      <img :src="imageSrc" alt="Placeholder" />
      <!-- 根据 showMask 状态显示蒙版 -->
      <div v-if="showMask" class="mask">
        <!-- 顶部线条 -->
        <div class="line top-line"></div>
        <!-- 右侧线条 -->
        <div class="line right-line"></div>
        <!-- 底部线条 -->
        <div class="line bottom-line"></div>
        <!-- 左侧线条 -->
        <div class="line left-line"></div>
      </div>
    </div>
  </div>
</template>
  
  <script>
export default {
  // 定义组件接收的 props
  props: {
    // 图片的 src 属性，默认使用占位图
    imageSrc: {
      type: String,
      default: "https://dummyimage.com/400x400/000/fff",
    },
  },
  data() {
    return {
      // 控制图片是否显示
      show: false,
      // 控制蒙版是否显示
      showMask: false,
    };
  },
  methods: {
    // 切换图片显示状态的方法
    toggleShow() {
      this.show = !this.show;
    },
  },
};
</script>
  
  <style scoped>
/* 图片容器样式 */
.image-container {
  position: relative;
  display: inline-block;
  padding: 10px;
  --line-color: #00fff2;
  --line-width: 4px;
  width: 100%;
  height: 100%;
}

/* 图片样式 */
.image-container img {
  width: 100%;
  height: 100%;
}

/* 蒙版样式 */
.mask {
  position: absolute;
  inset: 10px;
  background-color: rgba(0, 0, 0, 0.5);
  opacity: 0;
  transition: opacity 0.3s cubic-bezier(0.25, 0.1, 0.25, 1);
}

/* 鼠标悬停时显示蒙版 */
.image-container:hover .mask {
  opacity: 1;
}

/* 线条通用样式 */
.line {
  position: absolute;
  background-color: var(--line-color);
  animation-duration: 0.5s;
  animation-timing-function: cubic-bezier(0.25, 0.1, 0.25, 1);
  animation-iteration-count: 1;
  width: var(--line-width);
  height: var(--line-width);
}

/* 顶部线条样式及动画 */
.top-line {
  top: 10px;
  left: 10px;
  width: 0;
  height: var(--line-width);
  animation-name: draw-top;
}

/* 右侧线条样式及动画 */
.right-line {
  top: 10px;
  right: 10px;
  width: var(--line-width);
  height: 0;
  animation-name: draw-right;
}

/* 底部线条样式及动画 */
.bottom-line {
  bottom: 10px;
  right: 10px;
  width: 0;
  height: var(--line-width);
  animation-name: draw-bottom;
}

/* 左侧线条样式及动画 */
.left-line {
  bottom: 10px;
  left: 10px;
  width: var(--line-width);
  height: 0;
  animation-name: draw-left;
}

/* 顶部线条动画关键帧 */
@keyframes draw-top {
  0% {
    width: 0;
  }
  25% {
    width: calc(100% - 20px);
  }
  100% {
    width: calc(100% - 20px);
  }
}

/* 右侧线条动画关键帧 */
@keyframes draw-right {
  0% {
    height: 0;
  }
  25% {
    height: 0;
  }
  50% {
    height: calc(100% - 20px);
  }
  100% {
    height: calc(100% - 20px);
  }
}

/* 底部线条动画关键帧 */
@keyframes draw-bottom {
  0% {
    width: 0;
  }
  50% {
    width: 0;
  }
  75% {
    width: calc(100% - 20px);
  }
  100% {
    width: calc(100% - 20px);
  }
}

/* 左侧线条动画关键帧 */
@keyframes draw-left {
  0% {
    height: 0;
  }
  75% {
    height: 0;
  }
  100% {
    height: calc(100% - 20px);
  }
}

/* 鼠标悬停时线条保持显示 */
.image-container:hover .line {
  animation-fill-mode: forwards;
}
</style>    